import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import spanish from "./es/es";
import english from "./en/en";
import portuguese from "./pt/pt";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
let language = navigator.language.split("-")[0];
const supportedLanguages = ["es", "en", "pt"];
language = supportedLanguages.includes(language) ? language : "en";

moment.locale(language);

const resources = {
  es: {
    translation: spanish,
  },
  en: {
    translation: english,
  },
  pt: {
    translation: portuguese,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: language,
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
